const CHANGE_VALUE = '@@password/CHANGE_VALUE';
const DISPLAY_ERRORS = '@@password/DISPLAY_ERRORS';

const REQUEST_SAVE = '@@password/REQUEST_SAVE';
const SAVE_RESPONSE = '@@password/SAVE_RESPONSE';

export default {
    CHANGE_VALUE,
    DISPLAY_ERRORS,
    REQUEST_SAVE,
    SAVE_RESPONSE
};